import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationUseHeroXpBoostArgs,
  UseHeroXpBoostResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation UseHeroXpBoost($playerId: String!, $potionId: String!, $heroHandle: String!) {
  useHeroXpBoost(playerId: $playerId, potionId: $potionId, heroHandle: $heroHandle) {
    inventory
    hero_roster
  }
}
`;

export default async function mutationUseHeroXpBoost(
  args: MutationUseHeroXpBoostArgs
): Promise<UseHeroXpBoostResult> {
  return await graphqlClient.request<UseHeroXpBoostResult>(
    'useHeroXpBoost',
    mutation,
    args
  );
}
